// @ts-nocheck

import { CardModes } from '../../types/common';
import palette from '../palette';

export const FavoriteButton = {
  selected: { color: palette.white },
  normal: {
    color: palette.bluegrey900,
    stroke: palette.bluegrey600,
  },
  mymatch: {
    color: 'rgba(255, 255, 255, 0.1)',
    stroke: 'rgba(255, 255, 255, 0.3)',
  },
};

export const ExpandButton = {
  backgroundColor: palette.bluegrey850,
  titleColor: palette.neutralgrey300,
};

export const MatchCardMoreBetsButton = {
  normal: {
    valueColor: palette.white,
    backgroundColor: palette.transparent,
    valueLabelColor: palette.neutralgrey350,
  },
  active: {
    backgroundColor: palette.black,
  },
};

export const MatchCard = {
  backgroundColor: palette.bluegrey900,
  subTitle: {
    color: palette.neutralgrey350,
    hoverColor: palette.white,
  },
  alternativeMainBetColor: palette.white,
  alternativeMainBetSideBlocksBg: palette.bluegrey750,
};

export const MatchCardSeparator = {
  text: {
    color: palette.neutralgrey550,
  },
};

export const BoostedOddCard = {
  backgroundColor: palette.bluegrey900,
  subTitle: {
    color: palette.white,
  },
  title: {
    color: palette.bluegrey250,
  },
  badge: {
    [CardModes.BOOSTED]: {
      color: palette.white,
      iconColor: palette.silver50,
      backgroundImage: palette.boostedbage,
    },
    [CardModes.BIG_BOOSTED]: {
      color: palette.gold200,
      iconColor: palette.gold200,
      backgroundImage: palette.boostedbage,
    },
    [CardModes.XMAS_BOOSTED]: {
      color: palette.redwinamax450,
      iconColor: palette.redwinamax400,
      backgroundImage: palette.boostedbage,
    },
  },
  borderColor: {
    [CardModes.BOOSTED]: palette.silver200,
    [CardModes.BIG_BOOSTED]: palette.gold75,
    [CardModes.XMAS_BOOSTED]: palette.redwinamax450,
  },
};

export const MatchCardHeaderBadge = {
  mainBackgroundColor: palette.bluegrey850,
  liveBackgroundColor: palette.yellowwinamax450,
  liveColor: palette.black,
  Delimiter: {
    backgroundColor: palette.bluegrey850,
  },
};

export const MatchCardHeader = {
  backgroundColor: palette.bluegrey850,
  basketBackgroundColor: palette.bluegrey925, // TODO: should remove and use backgroundColor when redesign basket
  Timer: {
    color: palette.neutralgrey200,
  },
  [CardModes.BOOSTED]: {
    color: palette.black,
  },
  [CardModes.BIG_BOOSTED]: {
    color: palette.black,
  },
  [CardModes.XMAS_BOOSTED]: {
    color: palette.white,
  },
};
